if (!window.__ajaxPaginationBound) {
  window.__ajaxPaginationBound = true;

  document.addEventListener('click', async function (event) {
    const root = event.target.closest('#ajax-pagination');
    if (!root) return;

    const button = root.querySelector('button') || root;
    if (button.disabled) return;

    const nextUrl = root.getAttribute('data-next-url');
    if (!nextUrl) return;

    const section = root.closest('.shopify-section');
    const url = new URL(nextUrl, window.location.origin);
    if (section) url.searchParams.set('section_id', section.id.replace('shopify-section-', ''));

    const content = button.querySelector('.button__content');
    const loadMoreButtonLabel = root.getAttribute('data-load-more-button-label');
    const loadMoreLoadingLabel = root.getAttribute('data-load-more-loading-label');

    const setBusy = function (isBusy) {
      button.disabled = isBusy;

      if (isBusy) {
        button.setAttribute('aria-busy', 'true');
        if (loadMoreLoadingLabel) {
          button.setAttribute('aria-label', loadMoreLoadingLabel);
          if (content) content.textContent = loadMoreLoadingLabel;
        }
      } else {
        button.removeAttribute('aria-busy');
        if (loadMoreButtonLabel) {
          button.setAttribute('aria-label', loadMoreButtonLabel);
          if (content) content.textContent = loadMoreButtonLabel;
        } else {
          button.removeAttribute('aria-label');
        }
      }
    };

    setBusy(true);

    try {
      const html = await (await fetch(url)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nextList = doc.querySelector('#collection product-list');
      const liveList = document.querySelector('#collection product-list');

      if (nextList && liveList) {
        liveList.querySelectorAll('[reveal-on-scroll="true"]').forEach(function (node) {
          node.removeAttribute('reveal-on-scroll');
        });

        liveList.append(...Array.from(nextList.children).map(function (node) {
          return document.importNode(node, true);
        }));

        if (typeof liveList.reveal === 'function') {
          liveList.reveal();
        } else {
          liveList.querySelectorAll('[reveal-on-scroll="true"]').forEach(function (node) {
            node.removeAttribute('reveal-on-scroll');
          });
        }
      }

      const parsedRoot = doc.querySelector('#ajax-pagination');
      const parsedNextUrl = parsedRoot && parsedRoot.getAttribute('data-next-url');

      if (parsedNextUrl) {
        root.setAttribute('data-next-url', parsedNextUrl);
        setBusy(false);
      } else {
        root.hidden = true;
        setBusy(false);
      }
    } catch (error) {
      console.error(error);
      setBusy(false);
    }
  });
}